import { create } from 'zustand'

import { GitHubIssue } from '@/lib/github/types'
import { StreamedChatMessage } from '@/components/Chat'
import { StreamEvent } from '@langchain/core/tracers/log_stream'

export const useDrawer = create<{
  leftDrawer: Drawer
  rightDrawer: Drawer
  setLeftDrawer: (drawer: Drawer) => void
  setRightDrawer: (drawer: Drawer) => void
}>(set => ({
  leftDrawer: null,
  rightDrawer: null,
  setLeftDrawer: (drawer: Drawer) => set({ leftDrawer: drawer }),
  setRightDrawer: (drawer: Drawer) => set({ rightDrawer: drawer })
}))

export const useIssues = create<{
  issues: GitHubIssue[]
  setIssues: (issues: GitHubIssue[]) => void
  issuesLoading: IssuesLoading
  setIssuesLoading: (issuesLoading: Partial<IssuesLoading>) => void
}>(set => ({
  issues: [],
  setIssues: (issues: GitHubIssue[]) => set({ issues }),
  issuesLoading: { all: false },
  setIssuesLoading: (issuesLoading: Partial<IssuesLoading>) =>
    set(state => ({
      ...state,
      issuesLoading: {
        ...state.issuesLoading,
        ...issuesLoading,
        all:
          issuesLoading.all !== undefined
            ? issuesLoading.all
            : state.issuesLoading.all
      }
    }))
}))

export const useChat = create<{
  messages: Array<StreamedChatMessage>
  setMessages: (messages: Array<StreamedChatMessage>) => void
  isStreaming: boolean
  setIsStreaming: (isStreaming: boolean) => void
  streamEvents: StreamEventState
  addStreamEvent: AddStreamEvent
}>(set => ({
  messages: [],
  setMessages: (messages: Array<StreamedChatMessage>) => set({ messages }),
  isStreaming: false,
  setIsStreaming: (isStreaming: boolean) => set({ isStreaming }),
  streamEvents: {},
  addStreamEvent: (streamEvent: StreamEvent, threadId: string, key: string) =>
    set(state => ({
      streamEvents: {
        ...state.streamEvents,
        [threadId]: {
          ...state.streamEvents[threadId],
          [key]: [
            ...(state.streamEvents?.[threadId]?.[key]
              ? state.streamEvents[threadId]?.[key]
              : []),
            streamEvent
          ]
        }
      }
    }))
}))

export type Drawer = null | React.JSX.Element
export type IssuesLoading = { [key: number]: boolean; all: boolean }
export type AddStreamEvent = (
  streamEvent: StreamEvent,
  threadId: string,
  key: string
) => void
export type StreamEventState = Record<string, Record<string, StreamEvent[]>>
